import { useState } from "react";
import { HelpfulProps } from "@/common-components-src/api/reviews/review.interface";
import { handleHelpfulOperation } from "@/common-components-src/api/reviews/review.api";
import styles from "./reviews.module.scss";
import cn from "clsx";
import UKToast from "@/components/UKToast/index";
import ZanIcon from "@/assets/icons/zan.svg";
import ZanActiveIcon from "@/assets/icons/zan-on.svg";
import { sendClickTrack as reviewDetailSendClickTrack } from "@/tracks/25347";
import { useTranslation } from "@/i18n/client";
import { useStores } from "@/models";

interface HelpProps {
  data: HelpfulProps;
  pageType?: string;
  expConfig?: any;
}

export default function HelpfulButton({ data, pageType, expConfig }: HelpProps) {
  const { t } = useTranslation();
  const { commentOpstsStore } = useStores();
  const { helpfulNum, commentId, currentIsHelp } = data || {};
  const [helpNum, setHelpNum] = useState<string>(helpfulNum || "0");
  const [helpfulState, setHelpfulState] = useState<boolean>(currentIsHelp);

  const onHandle = async (event: React.MouseEvent) => {
    const res = await handleHelpfulOperation({
      commentId: commentId,
      operation: helpfulState ? 2 : 1,
    });
    if (res?.data?.result) {
      setHelpfulState(!helpfulState);
      const { likeCount } = res?.data || {};
      setHelpNum(likeCount !== "0" ? likeCount || "0" : "0");
      commentOpstsStore.changeHelpState(commentId, {
        helpfulState: !helpfulState,
        helpfulNum: likeCount,
      });
    } else {
      UKToast.show({
        icon: "error",
        content: res?.msg || t("common.message.tryAgain"),
      });
    }
    event.preventDefault();
  };

  const onHelpfulChange = (newCommentId: string, newValue: any) => {
    if (newCommentId === commentId) {
      setHelpNum(newValue.helpfulNum || "0");
      setHelpfulState(newValue.helpfulState);
    }
  }

  commentOpstsStore.onHelpfulChange(onHelpfulChange);

  return (
    <div
      className={cn(styles.helpfulBtn, helpfulState ? styles.active : "")}
      onClick={(e: any) => {
        onHandle(e);
        switch (pageType) {
          case "reviewDetail":
            reviewDetailSendClickTrack.Evaluate_CommentDetail_Card_Btn({ button_name: "1", commentId: `${commentId}`, skuid: `${data?.skuId}` || "-100" });
            break;

          default:
            break;
        }
      }}
      exptag={expConfig?.help?.expTag}
      data-exptag-json-param={JSON.stringify(expConfig?.help?.data)}
      data-exptag-config={expConfig?.help?.config}
    >
      {helpfulState ? <ZanActiveIcon className={cn(styles.zanIcon, styles.mar)} /> : <ZanIcon className={cn(styles.zanIcon, styles.mar)} />}
      {`${t("dp.commentSection.helpful")}`}<span className={styles.space}>{helpNum !== "0" ? "(" + helpNum + ")" : ""}</span>
    </div>
  );
}
